module.exports = __webpack_public_path__ + "static/media/MentorLouise.2e6588a3.jpeg";